import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutHalfFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutHalfFull"><Path d="M3 11V3H21V11L3 11Z" fill="currentColor"/><Path d="M3 13V21H21V13L3 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutHalfFull;
